import React, { memo, useCallback, useState } from 'react';
import { Icon, Popover } from 'antd';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import RoundedButton from '../../../../../components/RoundedButton/RoundedButton';
import SaveFilter from '../../../../../components/SaveFilter';
import { notificationConstants } from '../../../../../constants/notification.constants';
import { FILTER_NAME_VISIBLE_LENGTH } from '../../../../../helpers/filterName';
import { ReactComponent as DeleteIcon } from '../../../../../resource/DeleteIcon.svg';
import { filterActions } from '../../model/actions';
import { useRequestFilterCommands } from '../../model/commandsContext';
import { useFilterChangedState } from './useFilterChangedState';
import styles from './FilterFooter.module.scss';

const getFilterState = (state) => state.filterStore;
const selectIsSaving = (state) => getFilterState(state).saving;

const ActionButton = ({ variant, icon, iconType, children, ...props }) => (
  <RoundedButton
    {...props}
    text={children}
    className={cn(styles.btn, styles[variant])}
    iconLeft={
      icon ||
      (iconType && (
        <Icon
          type={iconType}
          className={styles.icon}
        />
      ))
    }
  />
);

const SaveForm = memo(({ onClose }) => {
  const dispatch = useDispatch();

  const handleSubmit = async ({ filterName }) => {
    onClose();
    dispatch(filterActions.save({ name: filterName.replace(/"/g, '\\"') }));
  };

  return (
    <div className={styles.formContainer}>
      <SaveFilter
        onSubmit={handleSubmit}
        onCancel={onClose}
        maxNameLength={FILTER_NAME_VISIBLE_LENGTH}
      />
    </div>
  );
});

const Save = () => {
  const isSaving = useSelector(selectIsSaving);
  const [visible, setVisible] = useState(false);
  const handleClose = useCallback(() => setVisible(false), []);

  return (
    <Popover
      content={<SaveForm onClose={handleClose} />}
      title="Введите название фильтра"
      trigger="click"
      placement="top"
      onVisibleChange={setVisible}
      visible={visible}
    >
      <ActionButton
        variant="saveBtn"
        iconType={isSaving ? 'loading' : 'plus-circle'}
      >
        Сохранить фильтр
      </ActionButton>
    </Popover>
  );
};

const Reset = () => {
  const dispatch = useDispatch();
  const filterCommands = useRequestFilterCommands();
  const { reset } = useFilterChangedState();

  const handleClick = async () => {
    dispatch({
      type: notificationConstants.NOTIFICATION_CLEAR,
      payload: null,
    });
    await dispatch(filterCommands.resetFilter());
    dispatch(filterActions.getList());
    reset();
  };

  return (
    <ActionButton
      variant="resetBtn"
      icon={<DeleteIcon className={styles.deleteIcon} />}
      onClick={handleClick}
    >
      Сбросить
    </ActionButton>
  );
};

const Apply = () => {
  const { changed, reset } = useFilterChangedState({
    shouldUpdateRequests: true,
  });

  return (
    <ActionButton
      variant="applyBtn"
      type="primary"
      onClick={reset}
      disabled={!changed}
    >
      Применить
    </ActionButton>
  );
};

const FilterFooter = () => (
  <div className={styles.root}>
    <div className={styles.leftBlock}>
      <Apply />
      <Reset />
    </div>
    <Save />
  </div>
);

export default memo(FilterFooter);
